export enum ConnectorStatusPopupArea {
    connectorStatusModal = 'connectorStatusModal',
}

export enum ConnectorStatusPopupAction {
    interactionConfirmed = 'interactionConfirmed',
    contactServiceDeskClicked = 'contactServiceDeskClicked',
}
